export type PreviewPathChangeDecision = 'acknowledge' | 'ignore' | 'navigate';

interface PreviewPathChangeState {
  reportedPath: string;
  editorPath: string;
  pendingPath: string | null;
  paused: boolean;
}

export function classifyPreviewPathChange(state: PreviewPathChangeState): PreviewPathChangeDecision {
  if (state.paused) return 'ignore';
  if (state.pendingPath === state.reportedPath) return 'acknowledge';
  return state.reportedPath === state.editorPath ? 'ignore' : 'navigate';
}
